import React, { useEffect, useRef, useState } from 'react';

export default function LazySection({
  children,
  fallback = null,
  rootMargin = '320px 0px',
  disabled = false,
  className = '',
  minHeight = '200px',
}) {
  const containerRef = useRef(null);
  const [shouldRender, setShouldRender] = useState(disabled);

  useEffect(() => {
    if (disabled) {
      setShouldRender(true);
      return;
    }

    if (shouldRender) return;

    if (typeof window === 'undefined' || typeof window.IntersectionObserver === 'undefined') {
      setShouldRender(true);
      return;
    }

    const node = containerRef.current;
    if (!node) {
      setShouldRender(true);
      return;
    }

    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldRender(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [disabled, rootMargin, shouldRender]);

  return (
    <div
      ref={containerRef}
      className={className}
      style={shouldRender ? undefined : { minHeight, containIntrinsicSize: `auto ${minHeight}` }}
    >
      {shouldRender ? children : fallback}
    </div>
  );
}
